import React from 'react';
import { Link } from 'react-router-dom';
import { Portal } from '../../types/landingPage';

interface PortalBannersSectionProps {
  banners: Portal[];
  title?: string;
  subtitle?: string;
}

const PortalBannersSection: React.FC<PortalBannersSectionProps> = ({
  banners,
  title = "Zniżka dla klientów Lokalnytrener:",
  subtitle = "Odkryj nasze specjalne oferty promocyjne"
}) => {
  if (!banners || banners.length === 0) {
    return null;
  }

  // Filter only active banners and sort by order
  const activeBanners = banners
    .filter(banner => banner.is_active)
    .sort((a, b) => a.order - b.order);

  if (activeBanners.length === 0) {
    return null;
  }

  return (
    <section className="landing-portal-banners">
      <div className="landing-container">
        <div className="landing-section-header">
          <h2>{title}</h2>
          {subtitle && (
            <p>{subtitle}</p>
          )}
        </div>

        <div className="landing-portal-banners-content">
          {activeBanners.map((banner) => (
            <div key={banner.id} className="landing-portal-banner">
              {banner.banner_link ? (
                <Link
                  to={banner.banner_link}
                  className="landing-portal-banner-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={banner.banner_image}
                    alt={banner.name}
                    className="landing-portal-banner-image"
                    style={{
                      width: '100%',
                      height: 'auto',
                      maxHeight: '350px',
                      objectFit: 'cover',
                      display: 'block',
                      borderRadius: '1rem'
                    }}
                  />
                </Link>
              ) : (
                <div className="landing-portal-banner-container">
                  <img
                    src={banner.banner_image}
                    alt={banner.name}
                    className="landing-portal-banner-image"
                    style={{
                      width: '100%',
                      height: 'auto',
                      maxHeight: '350px',
                      objectFit: 'cover',
                      display: 'block',
                      borderRadius: '1rem'
                    }}
                  />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PortalBannersSection;